(() => {
  // Read the native picker; keep copied and activated inquiry links in sync.
  const syncInquiry = (link) => {
    const scope = link.closest('.shopify-section');
    const picker = scope?.querySelector('variant-picker');
    const options = [];
    picker?.querySelectorAll('fieldset input:checked').forEach(input => {
      if (input.dataset.optionName && input.value && input.value !== 'Default Title') options.push(`${input.dataset.optionName}: ${input.value}`);
    });
    picker?.querySelectorAll('select').forEach(select => {
      const option = select.selectedOptions[0];
      if (option?.dataset.optionName && option.value && option.value !== 'Default Title') options.push(`${option.dataset.optionName}: ${option.value}`);
    });
    const url = new URL(link.dataset.productUrl, window.location.origin);
    const category = link.dataset.productCategory ? '\n\nCategory: ' + link.dataset.productCategory : '';
    const configuration = options.length ? '\n\nConfiguration: ' + options.join('; ') : '';
    const requestText = document.querySelector('#MainContent[data-template^="product"]') ? 'Please send specifications and quotation. I can provide medium, flow/head (or vacuum), temperature, power supply, quantity and destination.' : 'Please send me specifications and quotation.';
    const message = 'Hello HANVORAN, I’m interested in:\n' + link.dataset.productTitle + '\n\nProduct URL:\n' + url.href + category + configuration + '\n\n' + requestText;
    const href = `https://wa.me/${link.dataset.phone}?text=${encodeURIComponent(message)}`;
    if (link.href !== href) link.href = href;
  };
  const syncSection = (section) => {
    section?.querySelectorAll('[data-henvo-inquiry]').forEach(syncInquiry);
  };
  const observedSections = new WeakSet();
  const enhanceInquiries = (root = document) => {
    root.querySelectorAll('[data-henvo-inquiry]').forEach(link => {
      syncInquiry(link);
      const section = link.closest('.shopify-section');
      if (!section || observedSections.has(section)) return;
      observedSections.add(section);
      let queued = false;
      // Horizon replaces picker markup after a variant response arrives.
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          syncSection(section);
        });
      }).observe(section, { childList: true, subtree: true });
    });
  };
  document.addEventListener('change', event => {
    const picker = event.target.closest?.('variant-picker');
    if (picker) syncSection(picker.closest('.shopify-section'));
  });
  ['click', 'contextmenu', 'focusin'].forEach(type => {
    document.addEventListener(type, event => {
      const link = event.target.closest?.('[data-henvo-inquiry]');
      if (link) syncInquiry(link);
    });
  });
  const enhanceFaq = (root = document) => {
    root.querySelectorAll('[data-henvo-faq]').forEach(details => {
      if (details.dataset.enhanced) return;
      details.dataset.enhanced = 'true';
      const summary = details.querySelector('summary');
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', sync);
      sync();
    });
  };
  enhanceFaq();
  enhanceInquiries();
  document.addEventListener('shopify:section:load', event => {
    enhanceFaq(event.target);
    enhanceInquiries(event.target);
  });
})();

(() => {
  const previousLinks = new WeakMap();
  const readContext = () => {
    const main = document.getElementById('MainContent');
    if (!main || !['product', 'collection'].includes(main.dataset.inquiryPageType)) return null;
    return main.dataset;
  };
  const enhanceLink = (link, context) => {
    if (!context || !link.matches('a[href]')) return;
    const current = link.getAttribute('href');
    const previous = previousLinks.get(link);
    const original = previous && current === previous.output ? previous.original : current;
    let url;
    try { url = new URL(original, location.href); } catch { return; }
    if (url.hostname === 'wa.me' && url.pathname.replace(/^\/|\/$/g, '') === context.inquiryPhone) {
      let message = url.searchParams.get('text') || '';
      if (!/\bHANVORAN\b/i.test(message.replace(/https?:\/\/\S+/g, ''))) {
        message = context.inquiryGreeting + (message ? '\n\n' + message : '');
      }
      if (context.inquiryPageType === 'collection') {
        message += '\n\n' + context.inquiryCollectionLabel + ': ' + context.inquiryCollection;
        message += '\n' + context.inquirySourceLabel + ':\n' + context.inquirySourceUrl;
      } else if (!/https?:\/\/[^\s]+\/products\//.test(message)) {
        message += '\n\n' + context.inquiryProductLabel + ': ' + context.inquiryProductTitle;
        message += '\n' + context.inquirySourceLabel + ':\n' + context.inquirySourceUrl;
      }
      url.searchParams.set('text', message);
    } else if (context.inquiryPageType === 'collection' && url.origin === location.origin && url.pathname === context.inquiryContactPath) {
      url.searchParams.set('collection', context.inquiryCollection);
      url.searchParams.set('source_url', context.inquirySourceUrl);
      if (!url.searchParams.get('category')) url.searchParams.set('category', context.inquiryCollection);
    } else return;
    const output = url.href;
    previousLinks.set(link, { original, output });
    if (current !== output) link.setAttribute('href', output);
  };
  const enhance = (root = document) => {
    const context = readContext();
    if (!context) return;
    if (root.matches?.('a[href]')) enhanceLink(root, context);
    root.querySelectorAll?.('a[href]').forEach(link => enhanceLink(link, context));
  };
  const start = () => {
    if (!readContext()) return;
    enhance();
    const pending = new Set();
    let queued = false;
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') pending.add(record.target);
        else record.addedNodes.forEach(node => { if (node.nodeType === 1) pending.add(node); });
      }
      if (queued || !pending.size) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        const roots = [...pending];
        pending.clear();
        roots.forEach(root => { if (root.isConnected) enhance(root); });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    ['click', 'contextmenu', 'focusin'].forEach(type => {
      document.addEventListener(type, event => {
        const link = event.target.closest?.('a[href]');
        if (link) enhanceLink(link, readContext());
      });
    });
    document.addEventListener('shopify:section:load', event => enhance(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
